/////////// Encounter Note Types////////////////
// export const noteTypes = [
//     { display: "SOAP Note", value: "SOAP" },
//     { display: "GIRP Note", value: "GIRP" },
//     { display: "BIRP Note", value: "BIRP" },
//     { display: "DAP Note", value: "DAP" },
//     { display: "DAPP Note", value: "DAPP" },
//     { display: "Therapy Note", value: "Therapy" },
//     { display: "Massage Therapy Note", value: "Massage" },
//     { display: "Physical Therapy Note", value: "Physical" },
//     { display: "Other Note", value: "Other" },
//     // { display: "Therapy Note", value: "Therapy" },
//     // { display: "Progress Note", value: "Progress" },
// ];
/////////// Encounter Note Types////////////////
export const encounterStatus = [
    { display: "", value: "" },
    { display: "In Progress", value: "In Progress" },
    { display: "Ready for Review", value: "Ready for Review" },
    // { display: "Signed", value: "Signed" },
    // { display: "Therapy Note", value: "Therapy" },
    // { display: "Progress Note", value: "Progress" },
];

  // US Customary Units
  export const vitalUnitListUS = {
      Height: "in",
      Weight: "lb",
      BMI: "",
      "BMI Percentile": "%",
      BP: "mmHg",
      Temperature: "°F",
      Pulse: "bpm",
      "Respiratory Rate": "breaths/min",
      "O2 Saturation": "%",
      Pain: "",
      "Head Circumference": "in"
  };

  // Metric Units
  export const vitalUnitListMetric = {
      Height: "cm",
      Weight: "kg",
      BMI: "",
      "BMI Percentile": "%",
      BP: "mmHg",
      Temperature: "°C",
      Pulse: "bpm",
      "Respiratory Rate": "breaths/min",
      "O2 Saturation": "%",
      Pain: "",
      "Head Circumference": "cm"
  };

  // Empty (Else Case)
  export const vitalUnitListEmpty = {
      Height: "",
      Weight: "",
      BMI: "",
      "BMI Percentile": "",
      BP: "",
      Temperature: "",
      Pulse: "",
      "Respiratory Rate": "",
      "O2 Saturation": "",
      Pain: "",
      "Head Circumference": ""
  };
  // Assessment Area Treated
   export const AAT_OPTIONS = [
      { label: "Full Body", key: "AAT_FullBody" },
      { label: "Lower Body", key: "AAT_LowerBody" },
      { label: "Neck", key: "AAT_Neck" },
      { label: "Abdomen", key: "AAT_Abdoment" },
      { label: "Back(mid)", key: "AAT_BackMid" },
      { label: "Shoulder", key: "AAT_Shoulder" },
      { label: "Hand", key: "AAT_Hand" },
      { label: "Leg(upper)", key: "AAT_LegUpper" },
      { label: "Foot", key: "AAT_Foot" },
      { label: "Upper Body", key: "AAT_UpperBody" },
      { label: "Jaw", key: "AAT_Jaw" },
      { label: "Chest(Pectoral Region)", key: "AAT_Chest" },
      { label: "Back(upper)", key: "AAT_BackUpper" },
      { label: "Back(lower)", key: "AAT_BackLower" },
      { label: "Arm", key: "AAT_Arm" },
      { label: "Hip", key: "AAT_Hip" },
      { label: "Leg(lower)", key: "AAT_LegLower" },
      { label: "Other", key: "AAT_Other" },
    ];
  // Assessment Method Used
   export const AMU_OPTIONS = [
    { label: "Massage Therapy", key: "MassageTherapy" },
    { label: "Craniosacral", key: "Craniosacral" },
    { label: "Cupping", key: "Cupping" },
    { label: "Joint Mobilization", key: "JointMobilization" },
    { label: "Lymph Drainage", key: "LymphDrainage" },
  
    { label: "Myofascial Release", key: "MyofascialRelease" },
    { label: "Neuro Mobilization", key: "NeuroMobilization" },
    { label: "Stretching", key: "Stretching" },
    { label: "Taping", key: "Taping" },
    { label: "Trigger Point", key: "TriggerPoint" },
  
    { label: "Other", key: "Other" },
    ];